import { showToast } from './toast'; 

export const handleErrorResponse = (error: any, id?: string) => {
  const message =
    error?.data?.message || error?.message || 'Something went wrong!';

  showToast({
    title: 'An error occurred',
    description: message,
    status: 'error',
    id
  });
};
